import * as React from 'react'
import TextField from '@mui/material/TextField'
import Autocomplete from '@mui/material/Autocomplete'

import isEmpty from 'lodash/isEmpty'
import isObject from 'lodash/isObject'
import styled from '@emotion/styled'

const useStyles = styled((theme) => ({
  label: {
    backgroundColor: 'white',
    '&:hover': {
      background: 'white',
    },
  },
  paper: {
    textAlign: 'left',
  },
  root: {
    '& .MuiFilledInput-root': {
      background: 'white',
      '&:hover': {
        background: 'white',
      },
    },
    background: 'white',
  },
}))
export default function ComboBox({
  label,
  data,
  handleAutoComplete,
  name,
  selectedValue,
  sx,
  ...rest
}) {
  const classes = useStyles()
  const autoRef = React.useRef()
  return (
    <>
      <Autocomplete
        disablePortal
        name={name}
        ref={autoRef}
        {...rest}
        classes={{ paper: classes.paper }}
        value={selectedValue}
        options={!isEmpty(data) ? data : []}
        getOptionLabel={(data) => (!isEmpty(data) ? data.label : '')}
        sx={{ minWidth: '190px', marginTop: '10px', ...sx }}
        defaultValue={selectedValue}
        isOptionEqualToValue={(data, selectedValue) => {
          return !isEmpty(data)
            ? isObject(selectedValue)
              ? data.id === selectedValue.id
              : data.id === selectedValue
            : false
        }}
        onChange={(event, newValue) => {
          handleAutoComplete(autoRef.current.getAttribute('name'), newValue)
        }}
        size="small"
        renderInput={(params) => (
          <TextField
            // size='small'
            InputLabelProps={{
              classes: {
                root: classes.label,
              },
            }}
            className={classes.root}
            {...params}
            {...rest}
            label={label}
          />
        )}
      />
    </>
  )
}
